import React, { useState } from 'react';
import { ThemeProvider } from './ThemeContext';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import TopAppBar from './components/TopAppBar';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Terminal from './pages/Terminal';
import GuiDashboard from './pages/GuiDashboard';

function App() {
  const [currentView, setView] = useState('landing');

  return (
    <ThemeProvider>
      <div className="min-h-screen transition-colors duration-300 font-body bg-surface text-on-surface">
        <TopAppBar currentView={currentView} setView={setView} />

        <div className="pt-14 md:pt-16 pb-8 min-h-screen transition-all duration-300">
          {currentView === 'landing' && <Landing setView={setView} />}
          {currentView === 'gui' && <GuiDashboard setView={setView} />}
          {currentView === 'terminal' && <Terminal setView={setView} />}
        </div>

        <Footer />
        <Analytics />
        <SpeedInsights />
      </div>
    </ThemeProvider>
  );
}

export default App;
